import { useHits } from 'react-instantsearch';
import { HitAsset } from '../types';
import TableAssetItem from '@/components/table/TableAssetItem';

export default function CustomHitsAssets() {
  const { hits } = useHits<HitAsset>({});
  return (
    <>
      <div className="w-full">
        {hits.map((hit) => {
          const {
            id,
            title,
            date_published,
            category,
            ffbbsite_asset_tag_parent,
            ffbbsite_asset_type,
            ffbbsite_asset_tag_child,
            filesize
          } = hit;
          const assetTagDisplay =
            ffbbsite_asset_tag_parent === ffbbsite_asset_type && ffbbsite_asset_tag_child
              ? ffbbsite_asset_tag_child
              : ffbbsite_asset_tag_parent;
          return (
            <TableAssetItem
              key={id}
              category={category}
              uploaded_on={date_published || ''}
              id={id}
              title={title}
              filesize={filesize}
              ffbbsite_asset_tag_parent={assetTagDisplay}
            />
          );
        })}
      </div>
    </>
  );
}
